import React, { Component } from 'react'
import onClickOutside from "react-onclickoutside";
import styled from 'styled-components';


const Wrapper = styled.div`
    position: relative;
    display: inline-block;
    ${p => p.fitToSize ? '' : 'width: 100%'};
    font-size: inherit;
`

class DropdownWrapper extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdownOpen: false,
        }
    }

    handleClickOutside(evt) {
        this.setState({ dropdownOpen: false });
    }

    showDropdown(value) {
        this.setState({ dropdownOpen: value })
        if (this.props.isOpenAction) {
            this.props.isOpenAction(value);
        }
    }

    render() {

        let dropdownParts = this.props.children;

        if (!this.props.customClickable) {
            dropdownParts = React.Children.map(this.props.children, child => {
                return React.cloneElement(child, { showDropdown: (value) => this.showDropdown(value), dropdownOpen: this.state.dropdownOpen })
            })
        }

        return (
            <Wrapper fitToSize={this.props.fitToSize}>
                {dropdownParts}
            </Wrapper>
        )
    }
}

export default onClickOutside(DropdownWrapper);